import { Client, LookupItem } from "@amsanalytics/react-shared-library";
import { ClientPerformanceGroup } from "../../Models/ClientPerformanceGroup";
import { CreateDpgUser } from "../../Models/CreateDpgUser";
import { UpdateClientPerformanceGroup } from "../../Models/UpdateClientPerformanceGroup";
import { NiadaUser, User } from "../../Models/User";

export const LOAD_CLIENTS = "LOAD_CLIENTS";
export const LOAD_CLIENTS_SUCCESS = "LOAD_CLIENTS_SUCCESS";

export const CREATE_CLIENT = 'CREATE_CLIENT';
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS';

export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS';

export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';

export const LOAD_USERS_FOR_CLIENT = 'LOAD_USERS_FOR_CLIENT';
export const LOAD_USERS_FOR_CLIENT_SUCCESS = 'LOAD_USERS_FOR_CLIENT_SUCCESS';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const REMOVE_USER = 'REMOVE_USER';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';

export const RESEND_USER_INVITE = 'RESEND_USER_INVITE';
export const RESEND_USER_INVITE_SUCCESS = 'RESEND_USER_INVITE_SUCCESS';

export const CREATE_NIADA_USER = 'CREATE_NIADA_USER';
export const CREATE_NIADA_USER_SUCCESS = 'CREATE_NIADA_USER_SUCCESS';

export const REMOVE_NIADA_USER = 'REMOVE_NIADA_USER';
export const REMOVE_NIADA_USER_SUCCESS = 'REMOVE_NIADA_USER_SUCCESS';

export const LOAD_PERFORMANCE_GROUPS = 'LOAD_PERFORMANCE_GROUPS';
export const LOAD_PERFORMANCE_GROUPS_SUCCESS = 'LOAD_PERFORMANCE_GROUPS_SUCCESS';

export const GET_CLIENT_PERFORMANCE_GROUPS = 'GET_CLIENT_PERFORMANCE_GROUPS';
export const GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS = 'GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS';

export const CREATE_CLIENT_PERFORMANCE_GROUP = 'CREATE_CLIENT_PERFORMANCE_GROUP';
export const CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS = 'CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS';

export const UPDATE_CLIENT_PERFORMANCE_GROUP = 'UPDATE_CLIENT_PERFORMANCE_GROUP';
export const UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS = 'UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS';

export const DELETE_CLIENT_PERFORMANCE_GROUP = 'DELETE_CLIENT_PERFORMANCE_GROUP';
export const DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS = 'DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS';

// *** BEGIN ADMIN ACTIONS ***

// Get all clients
export interface LoadClientsAction {
  type: typeof LOAD_CLIENTS;
}
export const loadClients = (): LoadClientsAction => {
  return {
    type: LOAD_CLIENTS
  };
}
export interface LoadClientsSuccessAction {
  type: typeof LOAD_CLIENTS_SUCCESS;
  payload: { clients: Client[] };
}
export const loadClientsSuccess = (clients: Client[]): LoadClientsSuccessAction => {
  return {
    type: LOAD_CLIENTS_SUCCESS,
    payload: { clients }
  };
}

// Create Client
export interface CreateClientAction {
  type: typeof CREATE_CLIENT;
  payload: { client: Client };
}
export const createClient = (client: Client): CreateClientAction => {
  return {
    type: CREATE_CLIENT,
    payload: { client }
  };
}
export interface CreateClientSuccessAction {
  type: typeof CREATE_CLIENT_SUCCESS;
  payload: { client: Client };
}
export const createClientSuccess = (client: Client): CreateClientSuccessAction => {
  return {
    type: CREATE_CLIENT_SUCCESS,
    payload: { client }
  };
}

// Update Client
export interface UpdateClientAction {
  type: typeof UPDATE_CLIENT;
  payload: { client: Client };
}
export const updateClient = (client: Client): UpdateClientAction => {
  return {
    type: UPDATE_CLIENT,
    payload: { client }
  };
}

export interface UpdateClientSuccessAction {
  type: typeof UPDATE_CLIENT_SUCCESS;
  payload: { client: Client };
}
export const updateClientSuccess = (client: Client): UpdateClientSuccessAction => {
  return {
    type: UPDATE_CLIENT_SUCCESS,
    payload: { client }
  };
}

// Load Users
export interface LoadUsersAction {
  type: typeof LOAD_USERS;
}
export const loadUsers = (): LoadUsersAction => {
  return {
    type: LOAD_USERS
  };
}

export interface LoadUsersSuccessAction {
  type: typeof LOAD_USERS_SUCCESS;
  payload: { users: User[] };
}
export const loadUsersSuccess = (users: User[]): LoadUsersSuccessAction => {
  return {
    type: LOAD_USERS_SUCCESS,
    payload: { users }
  };
}

// Load all admin users
export const LOAD_MODERATORS = 'LOAD_MODERATORS';
export const LOAD_MODERATORS_SUCCESS = 'LOAD_MODERATORS_SUCCESS';

export interface LoadModeratorsAction {
  type: typeof LOAD_MODERATORS;
}
export const loadModerators = (): LoadModeratorsAction => {
  return {
    type: LOAD_MODERATORS
  };
}

export interface LoadModeratorsSuccessAction {
  type: typeof LOAD_MODERATORS_SUCCESS;
  payload: { users: NiadaUser[] };
}
export const loadModeratorsSuccess = (users: NiadaUser[]): LoadModeratorsSuccessAction => {
  return {
    type: LOAD_MODERATORS_SUCCESS,
    payload: { users }
  };
}

// Load Users for Client
export interface LoadUsersForClientAction {
  type: typeof LOAD_USERS_FOR_CLIENT;
  payload: { clientId: string };
}
export const loadUsersForClient = (clientId: string): LoadUsersForClientAction => {
  return {
    type: LOAD_USERS_FOR_CLIENT,
    payload: { clientId }
  };
}

export interface LoadUsersForClientSuccessAction {
  type: typeof LOAD_USERS_FOR_CLIENT_SUCCESS;
  payload: { users: User[] };
}
export const loadUsersForClientSuccess = (users: User[]): LoadUsersForClientSuccessAction => {
  return {
    type: LOAD_USERS_FOR_CLIENT_SUCCESS,
    payload: { users }
  };
}

// Create User
export interface CreateUserAction {
  type: typeof CREATE_USER;
  payload: { user: User };
}
export const createUser = (user: User): CreateUserAction => {
  return {
    type: CREATE_USER,
    payload: { user }
  };
}

export interface CreateUserSuccessAction {
  type: typeof CREATE_USER_SUCCESS;
  payload: { user: User };
}
export const createUserSuccess = (user: User): CreateUserSuccessAction => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: { user }
  };
}

// Update User
export interface UpdateUserAction {
  type: typeof UPDATE_USER;
  payload: { user: User };
}
export const updateUser = (user: User): UpdateUserAction => {
  return {
    type: UPDATE_USER,
    payload: { user }
  };
}

export interface UpdateUserSuccessAction {
  type: typeof UPDATE_USER_SUCCESS;
  payload: { user: User };
}
export const updateUserSuccess = (user: User): UpdateUserSuccessAction => {
  return {
    type: UPDATE_USER_SUCCESS,
    payload: { user }
  };
}

// Remove User
export interface RemoveUserAction {
  type: typeof REMOVE_USER;
  payload: { adUserId: string };
}
export const removeUser = (adUserId: string): RemoveUserAction => {
  return {
    type: REMOVE_USER,
    payload: { adUserId }
  };
}

export interface RemoveUserSuccessAction {
  type: typeof REMOVE_USER_SUCCESS;
  payload: { adUserId: string };
}
export const removeUserSuccess = (adUserId: string): RemoveUserSuccessAction => {
  return {
    type: REMOVE_USER_SUCCESS,
    payload: { adUserId }
  };
}

// Resend User Invite
export interface ResendUserInviteAction {
  type: typeof RESEND_USER_INVITE;
  payload: { adUserId: string };
}
export const resendUserInvite = (adUserId: string): ResendUserInviteAction => {
  return {
    type: RESEND_USER_INVITE,
    payload: { adUserId }
  };
}

export interface ResendUserInviteSuccessAction {
  type: typeof RESEND_USER_INVITE_SUCCESS;
  payload: { adUserId: string };
}
export const resendUserInviteSuccess = (adUserId: string): ResendUserInviteSuccessAction => {
  return {
    type: RESEND_USER_INVITE_SUCCESS,
    payload: { adUserId }
  };
}

// Create NIADA User
// export interface CreateDpgUserAction {
//   type: typeof CREATE_NIADA_USER;
//   payload: { dpgUser: CreateDpgUser };
// }
// export const createDpgUser = (dpgUser: CreateDpgUser): CreateDpgUserAction => {
//   return {
//     type: CREATE_NIADA_USER,
//     payload: { dpgUser }
//   };
// }

// export interface CreateDpgUserSuccessAction {
//   type: typeof CREATE_NIADA_USER_SUCCESS;
//   payload: { adUserId: string };
// }
// export const createDpgUserSuccess = (adUserId: string): CreateDpgUserSuccessAction => {
//   return {
//     type: CREATE_NIADA_USER_SUCCESS,
//     payload: { adUserId }
//   };
// }

// Remove NIADA User
export interface RemoveDpgUserAction {
  type: typeof REMOVE_NIADA_USER;
  payload: { adUserId: string };
}
export const removeDpgUser = (adUserId: string): RemoveDpgUserAction => {
  return {
    type: REMOVE_NIADA_USER,
    payload: { adUserId }
  };
}

export interface RemoveDpgUserSuccessAction {
  type: typeof REMOVE_NIADA_USER_SUCCESS;
  payload: { adUserId: string };
}
export const removeDpgUserSuccess = (adUserId: string): RemoveDpgUserSuccessAction => {
  return {
    type: REMOVE_NIADA_USER_SUCCESS,
    payload: { adUserId }
  };
}

export interface LoadPerformanceGroupsAction {
  type: typeof LOAD_PERFORMANCE_GROUPS;
}

export const loadPerformanceGroups = (): LoadPerformanceGroupsAction => {
  return {
    type: LOAD_PERFORMANCE_GROUPS
  };
};

export interface LoadPerformanceGroupsSuccessAction {
  type: typeof LOAD_PERFORMANCE_GROUPS_SUCCESS;
  payload: { performanceGroups: LookupItem[] };
}

export const loadPerformanceGroupsSuccess = (performanceGroups: LookupItem[]): LoadPerformanceGroupsSuccessAction => {
  return {
    type: LOAD_PERFORMANCE_GROUPS_SUCCESS,
    payload: { performanceGroups }
  };
};

export interface GetClientPerformanceGroupsAction {
  type: typeof GET_CLIENT_PERFORMANCE_GROUPS;
  payload: { clientId: string };
}

export const getClientPerformanceGroups = (clientId: string) => {
  return {
    type: GET_CLIENT_PERFORMANCE_GROUPS,
    payload: { clientId }
  };
}

export interface GetClientPerformanceGroupsSuccessAction {
  type: typeof GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS;
  payload: { clientPerformanceGroups: ClientPerformanceGroup[] };
}

export const getClientPerformanceGroupsSuccess = (clientPerformanceGroups: ClientPerformanceGroup[]): GetClientPerformanceGroupsSuccessAction => {
  return {
    type: GET_CLIENT_PERFORMANCE_GROUPS_SUCCESS,
    payload: { clientPerformanceGroups }
  };
};

// create client performance group
export interface CreateClientPerformanceGroupAction {
  type: typeof CREATE_CLIENT_PERFORMANCE_GROUP;
  payload: { clientPerformanceGroup: Omit<ClientPerformanceGroup, "id" | "performanceGroupName"> };
}

export const createClientPerformanceGroup = (clientPerformanceGroup: Omit<ClientPerformanceGroup, "id" | "performanceGroupName">): CreateClientPerformanceGroupAction => {
  return {
    type: CREATE_CLIENT_PERFORMANCE_GROUP,
    payload: { clientPerformanceGroup }
  };
};

export interface CreateClientPerformanceGroupSuccessAction {
  type: typeof CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS;
  payload: { clientPerformanceGroup: ClientPerformanceGroup };
}

export const createClientPerformanceGroupSuccess = (clientPerformanceGroup: ClientPerformanceGroup): CreateClientPerformanceGroupSuccessAction => {
  return {
    type: CREATE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
    payload: { clientPerformanceGroup }
  };
};

// Update client performance group
export interface UpdateClientPerformanceGroupAction {
  type: typeof UPDATE_CLIENT_PERFORMANCE_GROUP;
  payload: { clientPerformanceGroup: UpdateClientPerformanceGroup };
}

export const updateClientPerformanceGroup = (clientPerformanceGroup: UpdateClientPerformanceGroup): UpdateClientPerformanceGroupAction => {
  return {
    type: UPDATE_CLIENT_PERFORMANCE_GROUP,
    payload: { clientPerformanceGroup }
  };
};

export interface UpdateClientPerformanceGroupSuccessAction {
  type: typeof UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS;
  payload: { clientPerformanceGroup: ClientPerformanceGroup };
}

export const updateClientPerformanceGroupSuccess = (clientPerformanceGroup: ClientPerformanceGroup): UpdateClientPerformanceGroupSuccessAction => {
  return {
    type: UPDATE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
    payload: { clientPerformanceGroup }
  };
};

// Delete client performance group

export interface DeleteClientPerformanceGroupAction {
  type: typeof DELETE_CLIENT_PERFORMANCE_GROUP;
  payload: { clientPerformanceGroupId: string };
}

export const deleteClientPerformanceGroup = (clientPerformanceGroupId: string): DeleteClientPerformanceGroupAction => {
  return {
    type: DELETE_CLIENT_PERFORMANCE_GROUP,
    payload: { clientPerformanceGroupId }
  };
};

export interface DeleteClientPerformanceGroupSuccessAction {
  type: typeof DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS;
  payload: { clientPerformanceGroupId: string };
}

export const deleteClientPerformanceGroupSuccess = (clientPerformanceGroupId: string): DeleteClientPerformanceGroupSuccessAction => {
  return {
    type: DELETE_CLIENT_PERFORMANCE_GROUP_SUCCESS,
    payload: { clientPerformanceGroupId }
  };
};

// *** END ADMIN ACTIONS ***

export type AdminAction =
  LoadClientsAction
  | LoadClientsSuccessAction
  | CreateClientAction
  | CreateClientSuccessAction
  | UpdateClientAction
  | UpdateClientSuccessAction
  | LoadUsersAction
  | LoadUsersSuccessAction
  | LoadUsersForClientAction
  | LoadUsersForClientSuccessAction
  | CreateUserAction
  | CreateUserSuccessAction
  | UpdateUserAction
  | UpdateUserSuccessAction
  | RemoveUserAction
  | RemoveUserSuccessAction
  | ResendUserInviteAction
  | ResendUserInviteSuccessAction
  // | CreateDpgUserAction
  // | CreateDpgUserSuccessAction
  | RemoveDpgUserAction
  | RemoveDpgUserSuccessAction
  | LoadPerformanceGroupsAction
  | LoadPerformanceGroupsSuccessAction
  | GetClientPerformanceGroupsAction
  | GetClientPerformanceGroupsSuccessAction
  | CreateClientPerformanceGroupAction
  | CreateClientPerformanceGroupSuccessAction
  | UpdateClientPerformanceGroupAction
  | UpdateClientPerformanceGroupSuccessAction
  | DeleteClientPerformanceGroupAction
  | DeleteClientPerformanceGroupSuccessAction
  | LoadModeratorsSuccessAction;